// Options shared by the registration form (ULC-3111) and the graduation date modal (ULC-3523).

export const MONTH_OPTIONS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
].map((title, i) => ({ title, value: String(i + 1).padStart(2, '0') }));

// Up to 10 years out, oldest first. The modal also offers 10 years back ("graduated or
// expect to graduate"); registration asks for an expected date, so it doesn't. Matches the API.
export const GRADUATION_YEAR_SPAN = 10;

export function graduationYearOptions(now = new Date(), { yearsBack = 0 } = {}) {
  const firstYear = now.getFullYear() - yearsBack;
  return Array.from({ length: yearsBack + GRADUATION_YEAR_SPAN + 1 }, (_, i) => String(firstYear + i));
}

export const HIGH_SCHOOL_TYPES = [
  'Public High School',
  'Charter School',
  'Private/Independent School',
  'Home School or Home School Co-op',
  'Other'
];

// Keeps month/year menus on screen; see `.ea-select-menu--short` in styles/menu.css.
export const SHORT_MENU_PROPS = { maxHeight: 240, contentClass: 'ea-select-menu--short' };

// 'YYYY-MM' (or 'YYYY-MM-DD') -> 'May 2028'
export function formatGraduationDate(value) {
  const [year, month] = String(value || '').split('-');
  const option = MONTH_OPTIONS.find((m) => m.value === month);
  return option && /^\d{4}$/.test(year) ? `${option.title} ${year}` : '';
}

// Connector errors carry the Axios request (auth headers, payload); report only safe fields.
export function toReportableError(err, label) {
  const reportable = new Error(`${label}: ${err?.message || 'unknown error'}`);
  reportable.status = err?.status;
  reportable.errorCode = err?.errorCode;
  return reportable;
}
